import Link from "next/link"
function Footer() {
	return (
		<footer className='py-10 lg:py-[45px] bg-[#313037] --align text-white' style={{ fontFamily : 'League Spartan, sans-serif' }}>
			<div className="lg:hidden">
				<img className="mb-[26px]" src="/LogoWhite.png" alt="Logo" />

				<div className="flex">
					<div className="w-[40%]">
						<Link className="block font-[300] text-[12px] mb-[26px]" href={'https://apidrug.s3.amazonaws.com/media/apidrug.com_-Privacy_Policy_Updated.pdf'} target="_blank"> Privacy Policy </Link>
						<Link className="block font-[300] text-[12px] mb-[26px]" href="https://apidrug.s3.amazonaws.com/media/APIdrug_terms_of_service.pdf" target="_blank"> Terms of Service </Link>
						<Link className="block font-[300] text-[12px] mb-[26px]" href={'/products/all'} target="_blank"> All Products </Link>
						<Link className="block font-[300] text-[12px] mb-[26px]" href={'/blogs'} target="_blank"> Blogs </Link>
						<Link className="block font-[300] text-[12px] mb-[26px]" href={'/spot-buying'} target="_blank"> Spot Buying </Link>
					</div>

					<div className="w-[60%]">
						<div className="flex items-start mb-[26px]">
							<img src="/Footer/Address.svg" alt="address" className="mr-2"/>
							<small className="font-[300] text-[12px]">Boston Ivy Holdco pte ltd, 600 North Bridge Road, #23-01, parkview square, Singapore 188778</small>
						</div>

						<div className="flex items-start mb-[26px]">
							<img src="/Footer/Call.svg" alt="call" className="mr-2"/>

							<small className="font-[300] text-[12px]">
								<a href="tel:+91-8655735634">+91-8655735634</a>
							</small>
						</div>

						<div className="flex items-start">
							<img src="/Footer/Email.svg" alt="" className="mr-2"/>
							<small className="font-[300] text-[12px]">
								<a href="mailto:support@apidrug.com">support@apidrug.com</a>
							</small>
						</div>
					</div>
				</div>

				<div className="flex">
					<div className="flex items-start justify-between w-[30%] md:justify-start">
						<Link href={'/'} className="inline-block md:mr-4">
							<img className="w-[20px] h-[20px] rounded-[50%]" src="/Footer/Facebook.svg" alt="Facebook" />
						</Link>

						<Link href={'/'} className="inline-block md:mr-4">
							<img className="w-[20px] h-[20px]" src="/Footer/LinkedIn.svg" alt="Linkedin" />
						</Link>

						<Link href={'/'} className="inline-block md:mr-4">
							<img className="w-[23px] h-[23px]" src="/Footer/Twitter.svg" alt="Twitter" />
						</Link>
					</div>

					<div className="text-right w-[70%]">
						<small className="font-[300] text-[12px]">Copyright © { new Date().getFullYear() } • Boston Ivy Holdco pte ltd</small>
					</div>
				</div>
			</div>

			<div className="">
				<div className="hidden lg:flex lg:justify-between">
					<div className="flex justify-between w-[70%]">
						<img className="w-[118px] h-[30.75px]" src="/LogoWhite.png" alt="Logo" />

						<div className="flex justify-between w-[60%] mt-3">
							<Link className="block font-[300] text-[12px]" href={'https://apidrug-in.s3.amazonaws.com/media/apidrug.com_-Privacy_Policy_Updated.pdf'} target="_blank"> Privacy Policy </Link>
							<Link className="block font-[300] text-[12px]" href="https://apidrug-in.s3.amazonaws.com/media/APIdrug_terms_of_service.pdf" target="_blank"> Terms of Service </Link>
							<Link className="block font-[300] text-[12px]" href={'/products/all'} target="_blank"> All Products </Link>
							<Link className="block font-[300] text-[12px]" href={'/blogs'} target="_blank"> Blogs </Link>
							<Link className="block font-[300] text-[12px]" href={'/spot-buying'} target="_blank"> Spot Buying </Link>
							<Link className="block font-[300] text-[12px]" href={`${process.env.NEXT_PUBLIC_SELLER_HOME_PAGE_URL}`} target="_blank"> Sell on APIdrug </Link>
						</div>

						<div className="flex items-start justify-center w-[20%] mt-3">
							<Link href={'/'} className="inline-block md:mr-4">
								<img className="w-[17px] h-[17px] rounded-[50%]" src="/Footer/Facebook.svg" alt="Facebook" />
							</Link>

							<Link href={'/'} className="inline-block md:mr-4">
								<img className="w-[17px] h-[17px]" src="/Footer/LinkedIn.svg" alt="Linkedin" />
							</Link>

							<Link href={'/'} className="inline-block md:mr-4">
								<img className="w-[20px] h-[20px]" src="/Footer/Twitter.svg" alt="Twitter" />
							</Link>
						</div>
					</div>

					<div className="flex items-start mb-[26px] w-[30%] mt-3">
						<img src="/Footer/Address.svg" alt="address" className="mr-2"/>
						<small className="font-[300] text-[12px]">Boston Ivy Holdco pte ltd, 600 North Bridge Road, #23-01, parkview square, Singapore 188778</small>
					</div>
				</div>

				<div className="hidden lg:flex justify-between items-center">
					<div className="">
						<small className="font-[300] text-[12px]">Copyright © { new Date().getFullYear() } • Boston Ivy Holdco pte ltd</small>
					</div>

					<div className="flex w-[30%]">
						<div className="flex items-start mr-[25px]">
							<img src="/Footer/Call.svg" alt="call" className="mr-2"/>

							<small className="font-[300] text-[12px]">
								<a href="tel:+91-8655735634">+91-8655735634</a>
							</small>
						</div>

						<div className="flex items-start">
							<img src="/Footer/Email.svg" alt="" className="mr-2"/>
							<small className="font-[300] text-[12px]">
								<a href="mailto:support@apidrug.com">support@apidrug.com</a>
							</small>
						</div>
					</div>
				</div>
			</div>	
		</footer>
	)
}

export default Footer